'use client';

import { Link } from 'react-router-dom';
import { PageSEO } from '@/seo/PageSEO';
import styles from './License.module.css';

export function License() {
  return (
    <>
      <PageSEO
        title="Lisans ve Kullanım Koşulları | Bondex Sünger"
        description="Bondex Sünger web sitesi lisans ve kullanım koşulları. Telif hakları, içerik kullanımı ve yasal bilgiler."
        pathname="/lisans"
      />
      <main className={styles.licensePage}>
        <div className="container">
          <header className={styles.licenseHeader}>
            <nav className={styles.breadcrumb} aria-label="Breadcrumb">
              <Link to="/">Anasayfa</Link>
              <span> / </span>
              <span>Lisans ve Kullanım Koşulları</span>
            </nav>
            <h1 className={styles.licenseTitle}>Lisans ve Kullanım Koşulları</h1>
            <p className={styles.licenseSubtitle}>
              Son güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </header>

          <div className={styles.licenseContent}>
            <section className={styles.licenseSection}>
              <h2>Telif Hakları</h2>
              <p>
                Bu web sitesi ve içeriği, bariyerlibondexsunger.com'un telif hakkı koruması altındadır. Tüm metinler,
                görseller, logolar ve diğer içerikler, yasal koruma altındadır.
              </p>
              <p>
                © {new Date().getFullYear()} bariyerlibondexsunger.com - Tüm hakları saklıdır.
              </p>
            </section>

            <section className={styles.licenseSection}>
              <h2>İçerik Kullanımı</h2>
              <p>
                Bu web sitesindeki içerikler, yalnızca bilgilendirme amaçlıdır. İçeriklerin izinsiz kopyalanması,
                çoğaltılması veya dağıtılması yasaktır.
              </p>
              <p>
                İçerik kullanımı için önceden yazılı izin alınması gerekmektedir. İzin talepleri için{' '}
                <Link to="/sepet">iletişim</Link> sayfamızdan bizimle iletişime geçebilirsiniz.
              </p>
            </section>

            <section className={styles.licenseSection}>
              <h2>Görsel Kullanımı</h2>
              <p>
                Web sitesindeki tüm görseller, bariyerlibondexsunger.com'un mülkiyetindedir. Görsellerin izinsiz
                kullanımı telif hakkı ihlali oluşturur.
              </p>
              <p>
                Ürün görselleri ve logolar, yalnızca bu web sitesi içinde kullanılmak üzere lisanslanmıştır.
              </p>
            </section>

            <section className={styles.licenseSection}>
              <h2>İade ve İade Politikası</h2>
              <p>
                Ürünlerimiz için 14 gün içinde iade hakkınız bulunmaktadır. İade işlemleri ücretsizdir ve kargo
                masrafları tarafımızca karşılanır.
              </p>
              <p>
                İade koşulları ve süreci hakkında detaylı bilgi için{' '}
                <Link to="/sepet">iletişim</Link> sayfamızdan bizimle iletişime geçebilirsiniz.
              </p>
            </section>

            <section className={styles.licenseSection}>
              <h2>Yasal Uyarı</h2>
              <p>
                Bu web sitesindeki bilgiler, genel bilgilendirme amaçlıdır. Ürün özellikleri ve fiyatlar, önceden
                haber verilmeksizin değiştirilebilir.
              </p>
              <p>
                Ürün uygulamaları ve teknik detaylar hakkında kesin bilgi için lütfen{' '}
                <Link to="/sepet">uzman ekibimizle</Link> iletişime geçin.
              </p>
            </section>

            <section className={styles.licenseSection}>
              <h2>İletişim</h2>
              <p>
                Lisans ve kullanım koşulları hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
              <ul>
                <li>
                  <strong>Telefon:</strong> <a href="tel:+902165193411">0216 519 34 11</a>
                </li>
                <li>
                  <strong>WhatsApp:</strong>{' '}
                  <a href="https://wa.me/905469191134" target="_blank" rel="noopener noreferrer">
                    0546 919 11 34
                  </a>
                </li>
                <li>
                  <strong>E-posta:</strong> İletişim formu üzerinden
                </li>
              </ul>
            </section>
          </div>
        </div>
      </main>
    </>
  );
}

